export function formatTimeAgo(timestamp: number): string {
    const now = Date.now();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / (60 * 1000));
    const hours = Math.floor(minutes / 60);

    if (hours > 0) {
        return `${hours}h ${minutes % 60}m ago`;
    }
    return `${minutes} min ago`;
}

export function formatTimeUntil(timestamp: number): string {
    const now = Date.now();
    const diff = timestamp - now;
    const minutes = Math.floor(diff / (60 * 1000));
    const hours = Math.floor(minutes / 60);

    if (hours > 0) {
        return `In ${hours}h ${minutes % 60}m`;
    }
    return `In ${minutes}m`;
}